import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';
import Tooltip from '@material-ui/core/Tooltip';


const useStyles = makeStyles((theme) => ({
  fab: {
    margin: theme.spacing(2),
  },
  absolute: {
    position: 'fixed',
    bottom: theme.spacing(7),
    right: theme.spacing(3),
  },
}));

export default function ToolTip(props) {
  const classes = useStyles();

  

  return (
    <div>
      
      {props.openForm? <Tooltip style={{zIndex: 1}} title="Add" aria-label="add" onClick={props.openForm()}>
        <Fab color="primary" className={classes.absolute}>
          <AddIcon />
        </Fab>
      </Tooltip>
: <Tooltip title="Add" aria-label="add">
<Fab color="primary" className={classes.absolute}>
  <AddIcon />
</Fab>
</Tooltip>}
    </div>
  );
}
